// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "AnchorLinks-module--cds--assistive-text--OXubs";
export var cdsVisuallyHidden = "AnchorLinks-module--cds--visually-hidden--ikRAl";
export var hideFeedback = "AnchorLinks-module--hide-feedback--N-ucL";
export var link = "AnchorLinks-module--link--ER8-x";
export var list = "AnchorLinks-module--list--zGk4Z";
export var listSmall = "AnchorLinks-module--list--small--kM1JP";
export var multipleColumns = "AnchorLinks-module--multiple-columns--tpK7T";
export var showFeedback = "AnchorLinks-module--show-feedback--oBsvh";
export var skeleton = "AnchorLinks-module--skeleton--sWtvb";